// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Accordion_accordion-container__wERV2 {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}
.Accordion_accordion-container__wERV2 .Accordion_accordion__HQz1v {
  width: 100%;
  border: 1px solid #D0D5DD;
  border-radius: 4px;
  background-color: var(--m-card-background-color);
}
.Accordion_accordion-container__wERV2 .Accordion_accordion__header__255Jl {
  height: 50px;
  padding: 0 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}
.Accordion_accordion-container__wERV2 .Accordion_accordion__header__255Jl .Accordion_rotate__wsLJO {
  transform: rotate(-180deg);
  transition: ease-in-out 0.4s;
}
.Accordion_accordion-container__wERV2 .Accordion_accordion__header__255Jl.Accordion_active__tR5kN {
  color: var(--m-primary);
  font-weight: 500;
}
.Accordion_accordion-container__wERV2 .Accordion_accordion__inner__KpMtj {
  cursor: pointer;
  overflow: hidden;
  padding-left: 16px;
  padding-bottom: 16px;
  display: none;
  position: relative;
}
.Accordion_accordion-container__wERV2 .Accordion_accordion__inner__KpMtj.Accordion_visible__\\+52uI {
  display: block;
}
.Accordion_accordion-container__wERV2 .Accordion_accordion__inner__KpMtj .Accordion_inner__content__6aJfN > div {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.Accordion_accordion-container__wERV2 .Accordion_accordion__inner__KpMtj .Accordion_inner__content__6aJfN .Accordion_accordion-item-container__0L0Lz {
  display: none;
}
.Accordion_accordion-container__wERV2 .Accordion_accordion--borderless__vVmkv {
  border-color: transparent;
  padding: 0;
}
.Accordion_accordion-container__wERV2 .Accordion_accordion--borderless__vVmkv .Accordion_accordion__header__255Jl {
  background-color: transparent;
  color: unset;
  padding: 0;
}
.Accordion_accordion-container__wERV2 .Accordion_accordion--borderless__vVmkv .Accordion_accordion__inner__KpMtj {
  border-color: transparent;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.Accordion_accordion-container__wERV2 .Accordion_accordion--borderless__vVmkv .Accordion_accordion__inner__KpMtj .Accordion_inner__content__6aJfN {
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.Accordion_accordion-container--full__M65Mp {
  border: 1px solid #D0D5DD;
  border-radius: var(--m-border-radius);
}
.Accordion_accordion-container--full__M65Mp .Accordion_accordion__HQz1v {
  border: none;
}
.Accordion_accordion-container--full__M65Mp .Accordion_accordion__header__255Jl {
  border-top: 1px solid #D0D5DD;
}
.Accordion_accordion-container--full__M65Mp .Accordion_accordion__HQz1v:first-child .Accordion_accordion__header__255Jl {
  border-top: none;
}
.Accordion_accordion-container--borderless__WBYm5 {
  border-color: transparent;
}

[m-data-theme=dark] .Accordion_accordion-container__wERV2 .Accordion_accordion__HQz1v {
  border-color: var(--m-border-color);
  background-color: transparent;
}
[m-data-theme=dark] .Accordion_accordion-container__wERV2 .Accordion_accordion__header__255Jl {
  background-color: transparent;
  color: var(--m-text-light);
}
[m-data-theme=dark] .Accordion_accordion-container__wERV2 .Accordion_accordion__header__255Jl.Accordion_active__tR5kN {
  background-color: transparent;
}
[m-data-theme=dark] .Accordion_accordion-container__wERV2 .Accordion_accordion__inner__KpMtj {
  background-color: transparent;
  color: var(--m-text);
}
[m-data-theme=dark] .Accordion_accordion-container__wERV2 .Accordion_accordion__inner__KpMtj.Accordion_visible__\\+52uI {
  border-color: var(--m-border-color);
}
[m-data-theme=dark] .Accordion_accordion-container__wERV2 .Accordion_accordion--borderless__vVmkv {
  border-color: transparent;
}
[m-data-theme=dark] .Accordion_accordion-container--full__M65Mp {
  border-color: var(--m-border-color);
}
[m-data-theme=dark] .Accordion_accordion-container--full__M65Mp .Accordion_accordion__HQz1v {
  border: none;
}
[m-data-theme=dark] .Accordion_accordion-container--full__M65Mp .Accordion_accordion__header__255Jl {
  background-color: transparent;
  border-color: var(--m-border-color);
  border-radius: unset;
  color: var(--m-text-light);
}
[m-data-theme=dark] .Accordion_accordion-container--full__M65Mp .Accordion_accordion__HQz1v:first-child .Accordion_accordion__header__255Jl {
  border-top: none;
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Accordion/Accordion.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACJ;AACI;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gDAAA;AACR;AACQ;EACI,YAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AACZ;AACY;EACI,0BAAA;EACA,4BAAA;AAChB;AAEY;EACI,uBAAA;EACA,gBAAA;AAAhB;AAIQ;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;AAFZ;AAIY;EACI,cAAA;AAFhB;AAMgB;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAJpB;AAOgB;EACI,aAAA;AALpB;AAUQ;EACI,yBAAA;EACA,UAAA;AARZ;AAUY;EACI,6BAAA;EACA,YAAA;EACA,UAAA;AARhB;AAWY;EACI,yBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAThB;AAWgB;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AATpB;AAgBI;EACI,yBAAA;EACA,qCAAA;AAdR;AAgBQ;EACI,YAAA;AAdZ;AAgBY;EACI,6BAAA;AAdhB;AAkBgB;EACI,gBAAA;AAhBpB;AAsBI;EACI,yBAAA;AApBR;;AA0BQ;EACI,mCAAA;EACA,6BAAA;AAvBZ;AAyBY;EACI,6BAAA;EACA,0BAAA;AAvBhB;AAyBgB;EACI,6BAAA;AAvBpB;AA2BY;EACI,6BAAA;EACA,oBAAA;AAzBhB;AA2BgB;EACI,mCAAA;AAzBpB;AA6BY;EACI,yBAAA;AA3BhB;AA+BQ;EACI,mCAAA;AA7BZ;AA+BY;EACI,YAAA;AA7BhB;AA+BgB;EACI,6BAAA;EACA,mCAAA;EACA,oBAAA;EACA,0BAAA;AA7BpB;AAiCoB;EACI,gBAAA;AA/BxB","sourcesContent":[".accordion-container {\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n\n    .accordion {\n        width: 100%;\n        border: 1px solid #D0D5DD;\n        border-radius: 4px;\n        background-color: var(--m-card-background-color);\n  \n        &__header {\n            height: 50px;\n            padding: 0 16px;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            font-size: 14px;\n\n            .rotate {\n                transform: rotate(-180deg);\n                transition: ease-in-out .4s;\n            }\n\n            &.active {\n                color: var(--m-primary);\n                font-weight: 500;\n            }\n        }\n\n        &__inner {\n            cursor: pointer;\n            overflow: hidden;\n            padding-left: 16px;\n            padding-bottom: 16px;\n            display: none;\n            position: relative;\n\n            &.visible {\n                display: block;\n            }\n            \n            .inner__content {\n                > div {\n                    display: flex;\n                    flex-direction: column;\n                    gap: 8px;\n                }\n\n                .accordion-item-container {\n                    display: none;\n                }\n            }\n        }\n\n        &--borderless {\n            border-color: transparent;\n            padding: 0;\n\n            .accordion__header {\n                background-color: transparent;\n                color: unset;\n                padding: 0;\n            }\n\n            .accordion__inner {\n                border-color: transparent;\n                padding: 0;\n                display: flex;\n                flex-direction: column;\n                gap: 8px;\n                \n                .inner__content {\n                    padding: 0;\n                    display: flex;\n                    flex-direction: column;\n                    gap: 8px;\n                }\n            }\n        }\n    }\n\n    \n    &--full {\n        border: 1px solid #D0D5DD;\n        border-radius: var(--m-border-radius);\n\n        .accordion {\n            border: none;\n\n            &__header {\n                border-top: 1px solid #D0D5DD;\n            }\n\n            &:first-child {\n                .accordion__header {\n                    border-top: none;\n                }\n            }\n        }\n    }\n\n    &--borderless {\n        border-color: transparent;\n    }\n}\n\n[m-data-theme=\"dark\"] {\n    .accordion-container {\n        .accordion {\n            border-color: var(--m-border-color);\n            background-color: transparent;\n\n            &__header {\n                background-color: transparent;\n                color: var(--m-text-light);\n\n                &.active {\n                    background-color: transparent;\n                }\n            }\n\n            &__inner {\n                background-color: transparent;\n                color: var(--m-text);\n\n                &.visible {\n                    border-color: var(--m-border-color);\n                }\n            }\n\n            &--borderless {\n                border-color: transparent;\n            }\n        }\n\n        &--full {\n            border-color: var(--m-border-color);\n    \n            .accordion {\n                border: none;\n    \n                &__header {\n                    background-color: transparent;\n                    border-color: var(--m-border-color);\n                    border-radius: unset;\n                    color: var(--m-text-light);\n                }\n    \n                &:first-child {\n                    .accordion__header {\n                        border-top: none;\n                    }\n                }\n            }\n        }\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordion-container": `Accordion_accordion-container__wERV2`,
	"accordion": `Accordion_accordion__HQz1v`,
	"accordion__header": `Accordion_accordion__header__255Jl`,
	"rotate": `Accordion_rotate__wsLJO`,
	"active": `Accordion_active__tR5kN`,
	"accordion__inner": `Accordion_accordion__inner__KpMtj`,
	"visible": `Accordion_visible__+52uI`,
	"inner__content": `Accordion_inner__content__6aJfN`,
	"accordion-item-container": `Accordion_accordion-item-container__0L0Lz`,
	"accordion--borderless": `Accordion_accordion--borderless__vVmkv`,
	"accordion-container--full": `Accordion_accordion-container--full__M65Mp`,
	"accordion-container--borderless": `Accordion_accordion-container--borderless__WBYm5`
};
export default ___CSS_LOADER_EXPORT___;
